import { ApiClient } from 'api/types/api-client';
import { ApiRoutes, TrackingOptions, TrackingParams } from './types';
import { FetchApiClient } from '../fetch-api';
import { getCookie } from 'utils/cookie';
import { getTimestamp } from 'utils/get-timestamp';

export class TrackingApi {
  private readonly client: ApiClient;

  constructor(host: string, apiKey: string) {
    this.client = new FetchApiClient(host, apiKey);
  }

  private buildTrackingData(contentId: string): TrackingParams {
    const sessionValue = getCookie('rm_session') || '';

    return {
      link: {
        name: 'session',
        value: sessionValue,
      },
      impressionContentId: contentId,
      timestamp: getTimestamp(),
    };
  }

  public readonly impressionViewTracking = (
    contentId: string,
    options: TrackingOptions = {}
  ): Promise<void> => {
    const data = this.buildTrackingData(contentId);
    return this.client.post<void>(ApiRoutes.IMPRESSION_VIEW, data, options);
  };

  public readonly impressionClickTracking = (
    contentId: string,
    options: TrackingOptions = { keepalive: true }
  ): Promise<void> => {
    const data = this.buildTrackingData(contentId);

    return this.client.post<void>(ApiRoutes.IMPRESSION_CLICK, data, options);
  };
}
